<template>
  <div>
    <!-- <div class="left content-left">
      <AreaTree v-on:handleTreeClick="handleTreeClick" :moduleName="moduleName"></AreaTree>
    </div> -->
    <div>
      <!--左侧上方搜索框-->
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
            <label for>道路:</label>
            <search-parking></search-parking>
          </div>
          <div class="form-group">
            <label for>岗位:</label>
            <search-area></search-area>
          </div>
          <div class="form-group">
            <label for="bdate">进场时间:</label>
            <el-date-picker
              clearable
              value-format="yyyy-MM-dd HH:mm:ss"
              v-model="search.beginDate"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
            ></el-date-picker>
          </div>
          <div class="form-group">
            <label for="bdate">出场时间:</label>
            <el-date-picker
              clearable
              value-format="yyyy-MM-dd HH:mm:ss"
              v-model="search.chargeDate"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
            ></el-date-picker>
          </div>
          <div class="form-group">
            <label for>泊位:</label>
            <input
              v-model="search.spaceNum"
              class="form-control"
              id
              type="text"
              placeholder
              size="12"
            />
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <button
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
              >
                查询
              </button>
            </span>
          </div>
          <div class="form-group others">
            <button
              @click="downloadData"
              type="button"
              class="btn btn-primary"
              id="search_btn"
            >
              导出
            </button>
          </div>
        </form>
      </div>
      <!--左侧列表展示进出场记录-->
      <div class="list-right">
        <el-table
          ref="table"
          border
          :data="tableListData.rows"
          height="100%"
          width="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
        >
          <el-table-column
            show-overflow-tooltip
            label="停车道路"
            prop="parkingName"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="岗位"
            prop="areaName"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="泊位编号"
            prop="spaceNum"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="车牌"
            prop="carNumber"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="进场时间"
            prop="beginDate"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="出场时间"
            prop="endDate"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="地磁出场时间"
            prop="attr2"
          ></el-table-column>
          <el-table-column show-overflow-tooltip label="操作" width="150px">
            <template slot-scope="scope">
              <button class="delete" @click="del(scope.row.lmId)" type="button">
                删除
              </button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <Page v-on:pagination="receivePaginationData"></Page>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

import {
  delIORecord,
  getAllIOList,
  getIORecordList,
  dictValue,
  getAppList,
  getHandsetSingle,
  dealHandset,
} from "@/api/url";

import Page from "../../commons/page";

import AreaTree from "../../commons/areaTree";

import SearchParking from "@/page/commons/searchParking";

import SearchArea from "../../commons/searchArea";

export default {
  data() {
    return {
      treeData: {
        parkingId: "",
      },
      observer: null,
      recordOldValue: {
        // 记录下旧的宽高数据，避免重复触发回调函数
        elementHeight: "0",
      },
      observer1: null,
      innerRecordOldValue: {
        // 记录下旧的宽高数据，避免重复触发回调函数
        innerHeight: "0",
      },
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      moduleName: "",
      allFbType: [],
      search: {
        pageNumber: 1,
        pageSize: 10,
        spaceNum: null,
        beginDate: null,
        chargeDate: null,
      },
      tableListData: {
        rows: [],
      },
      tableListDataAll: {},

      defaultProps: {
        children: "children",
        label: "label",
      },
      downloadFileds: {
        停车道路: "parkingName",
        泊位段: 'attr7==undefind&&attr7==""?"":JSON.parse(attr7).areaName',
        泊位编号: "spaceNum",
        车牌: "carNumber",
        进场时间: "beginDate",
        出场时间: "endDate",
      },
      formLabelWidth: "100px",

      dialogFormVisiblePhoto: false,
      allImgUrl: [],
      imgUrl: "",
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },

    tableList: function (curPage) {
      var _this = this;

      this.$get(getIORecordList(), {
        inBeginTime:
          this.search.beginDate 
            ? JSON.stringify(this.search.beginDate)
            : null,
        outBeginTime:
          this.search.chargeDate
            ? JSON.stringify(this.search.chargeDate)
            :null ,
        limit: this.search.pageSize,
        page: curPage,
        parkingId: this.parking?.parkingId ?? null,
        areaId: this.area?.areaId ?? null,
        spaceNum: this.search.spaceNum?this.search.spaceNum:null,
      }).then((data) => {
        if (data.status != 200) return;
        //翻页

        var rows = data.data.rows;
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        _this.getPage(pageObj);
        _this.tableListData.rows = data.data.rows;
        _this.$nextTick(() => {
          _this.$refs.table.doLayout();
        });
      });
    },

    searchList: function () {
      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
    },
    clearSearch: function () {
      this.search.pageNumber = "1";
      this.search.fbMsg = "";
    },
    downloadData() {
      this.$downloadFileRequest(
        "/api/parking/lotMsg/lotMsgExport",
        {
          inBeginTime: !this.search.beginDate
            ? null
            : JSON.stringify(this.search.beginDate),
          outBeginTime: !this.search.chargeDate
            ? null
            : JSON.stringify(this.search.chargeDate),
          parkingId: this.parking?.parkingId ?? null,
          areaId: this.area?.areaId ?? null,
          spaceNum: this.search.spaceNum ? this.search.spaceNum : null,
        },
        "进出记录"
      );
    },
    del: function (id) {
      var _this = this;
      var index = _this.$layer.confirm(
        "您确定删除该记录吗？",
        {
          btn: ["确定", "取消"],
          shade: false,
          type: 0,
        },
        function () {
          _this.$layer.close(index);
          // console.log("222")
          _this.$deleteRequest(`${delIORecord()}/${id}`).then((data) => {
            if (data.status != 200)
              return _this.$layer.msg("删除失败", { time: 1 });
            _this.$notify({
              type: "success",
              title: "成功",
              message: "删除成功",
            });
            _this.tableList(_this.curIndex);
          });
        }
      );
    },
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
      parking: (state) => state.parking.oneParking,
      area: (state) => state.parking.area,
    }),
  },
  components: {
    Page,
    AreaTree,
    SearchParking,
    SearchArea,
    // Refresh
  },

  mounted: function () {
    this.tableList(this.search.pageNumber);
  },
};
</script>

<style scoped>
.boxbgcolor {
  width: 100%;
  display: flex;
}
.table tr td {
  text-align: center;
}

.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}
/* .left{
		width:20%;
		float:left;
		/*border-right:1px solid #278cd8;*/
/*margin-right:0.5%*/
/* }
	.right{
		width:80%;
		float:right;
		position:relative;
		height:660px;
	}  */
.table thread tr td {
  text-align: center;
}
.pagbox {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.searchbox {
  background: #f9f9fb;
  /* height:130px;
		line-height:45px; */
  border-bottom: 10px solid #eff2f7;
}
.form-inline {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  align-items: center;
  height: 90px;
}
.search_btn,
.download_btn,
.refresh_btn {
  display: inline-block;
}
.refresh_btn {
  display: -webkit-flex;
  display: flex;
  align-items: center;
}
.others {
  display: -webkit-flex;
  display: flex;
  justify-content: center;
}
</style>